import { defineMessages } from 'react-intl';
import { ACCOUNT, CARD, PAYMENT, REWARDS } from '../../claim-names';

const messages = defineMessages({
  [ACCOUNT]: {
    id: 'oauthAuthorize.claimsList.authorizeAccount',
    defaultMessage: 'Access your profile information',
    description:
      'Description of account information that will be shared with the client application.',
  },
  [CARD]: {
    id: 'oauthAuthorize.claimsList.authorizeCard',
    defaultMessage: 'Access your Starbucks Card transactions',
    description:
      'Description of card information that will be shared with the client application.',
  },
  [PAYMENT]: {
    id: 'oauthAuthorize.claimsList.authorizePayment',
    defaultMessage: 'Access information about your payment methods',
    description:
      'Description of payment information that will be shared with the client application.',
  },
  [REWARDS]: {
    id: 'oauthAuthorize.claimsList.authorizeRewards',
    defaultMessage: 'Access information about { starbucksRewardsTrademark }',
    description:
      'Description of rewards information that will be shared with the client application.',
  },
});

export default messages;
